/**
 * Detects if the current device is a mobile device based on user agent
 * @returns boolean indicating if the current device is mobile
 */
export const isMobileDevice = (): boolean => {
  const userAgent = 
    typeof window !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
  
  return (
    /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent) ||
    (userAgent.includes('mobi') || userAgent.includes('tablet'))
  );
};

/**
 * Checks if the Web Share API is available in the current browser
 * @returns boolean indicating if Web Share API is supported
 */
export const isWebShareSupported = (): boolean => {
  return typeof navigator !== 'undefined' && 
    typeof navigator.share === 'function';
};

/**
 * Attempts to share content via the Web Share API
 * @param url The URL to share
 * @param title The title to share
 * @param text Optional text to share
 * @returns Promise that resolves if successful, rejects if sharing failed or was cancelled
 */
export const shareViaWebShareApi = async (
  url: string, 
  title: string, 
  text?: string
): Promise<void> => {
  if (!isWebShareSupported()) {
    throw new Error('Web Share API not supported');
  }
  
  try {
    await navigator.share({
      title,
      text,
      url,
    });
  } catch (error) {
    // User cancelled or sharing failed
    throw error;
  }
};
